// extracted by mini-css-extract-plugin
module.exports = {"text":"content-module__text___Mq3qV"};